// extracted by mini-css-extract-plugin
export default {"tabsContainer":"styles_tabsContainer__8agi5","tabs":"styles_tabs__3sh0D","singleTab":"styles_singleTab__nARdQ","activeSingleTab":"styles_activeSingleTab__SAKFb"};